const MENU_SECTIONS_MIN_QUANTITY = 4;

function showSectionMenu(sections = []) {
  return sections?.length >= MENU_SECTIONS_MIN_QUANTITY;
}

export default showSectionMenu;
